import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  byMemriseLinguistTeam: {
    defaultMessage: `By Memrise Content Team`,
  },
});
